import { Component, ViewChild } from '@angular/core';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { DataSourceCustomAction } from '@m4u-angular/base/datalayer/BaseDataSources';
import { BaseState, DataEditorView, SystemCredentialInfo }
    from '@m4u-angular/base/entities/BaseEntities';
import { DataEditorEndpoint } from '@m4u-angular/core/endpoints/data-editor.endpoint';
import { WelcomeMessageConfigDialogComponent }
    from '@m4u-angular/ui/dialogs/welcome-message-config-dialog/welcome-message-config-dialog.component';

export class State extends BaseState {
    Views: DataEditorView[];
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-data-view-list',
    templateUrl: './data-view-list.component.html',
})
export class DataViewListComponent extends BasePageComponent<SystemCredentialInfo, State> {
    @ViewChild(WelcomeMessageConfigDialogComponent) dialog: WelcomeMessageConfigDialogComponent;

    constructor(A: ServiceBagService, private dataEditorEndpoint: DataEditorEndpoint) {
        super(A, 'DataViewListComponent', SystemCredentialInfo, State);
    }

    protected override OnInitComponent() {
        this.InitState();
        this.LoadDataSource();
    }

    private LoadDataSource() {
        this.Do(this.dataEditorEndpoint.ListViews(), false, (res) => this.State.Views = res.Entities);
    }

    CheckPerformance() {
        this.IsLoading = true;
        this.Do(this.dataEditorEndpoint.CheckPerformance({ Views: this.State.Views }), true, res => {
            this.State.Views = res.Entities;
            this.IsLoading = false;
        })
    }

    CheckValidity() {
        this.IsLoading = true;
        this.Do(this.dataEditorEndpoint.CheckValidity({ Views: this.State.Views }), true, res => {
            this.State.Views = res.Entities;
            this.IsLoading = false;
        })
    }
}
